import { __awaiter } from "tslib";
import * as htmlToImage from 'html-to-image';
import * as constants from './constants.js';
import { waitForElement } from './automation/waitForElement.js';
import dompurify from 'dompurify';
import * as cheerio from 'cheerio';
export class Utils {
    /**
     * Makes a deep clone of the node for further manipulation
     * @returns {Element | null}
     * @param node
     */
    static cloneNode(node) {
        let element;
        if (!(node instanceof Element)) {
            element = document.querySelector(`[data-document-parser-id="${node}"]`);
        }
        else {
            element = node;
        }
        if (element) {
            const clonedElement = document.createElement('div');
            clonedElement.append(element.cloneNode(true));
            return clonedElement;
        }
        return null;
    }
    /**
     *
     * makes a PNG image from any HTML selector
     * @returns {string} - base64 image representation
     * @param selector
     */
    static makeScreenshot(selector) {
        return __awaiter(this, void 0, void 0, function* () {
            const element = yield waitForElement(selector);
            if (element) {
                const blob = yield htmlToImage.toBlob(element, {
                    pixelRatio: 2,
                    width: element.scrollWidth,
                    canvasWidth: element.scrollWidth,
                });
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                return new Promise(resolve => {
                    reader.onloadend = () => {
                        resolve(reader.result ? reader.result.toString() : '');
                    };
                });
            }
            return '';
        });
    }
    static hasParentFromList(element, list) {
        for (const e of Array.from(list)) {
            if (e !== element && e.contains(element))
                return true;
        }
        return false;
    }
    /**
     * Removes all classes from the HTML string
     * @param htmlString
     * @returns {string}
     */
    static cleanClasses(htmlString) {
        // Load the HTML string into a Cheerio object
        const $ = cheerio.load(htmlString);
        // Select all elements with a class attribute and remove the attribute
        $('[class]').each(function () {
            $(this).removeAttr('class');
        });
        // Get the modified HTML as a string
        return $.html();
    }
    /**
     *
     * @param element
     * @param parentSelector
     */
    static countAllParentsBySelector(element, parentSelector) {
        var _a, _b;
        let parentCount = 0;
        while (element) {
            parentCount++;
            element = (_b = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.closest(parentSelector)) !== null && _b !== void 0 ? _b : null;
        }
        return --parentCount;
    }
    /**
     * If table contains different inputs (dropdown, checkbox, button, etc.)
     * all of them should be converted to simple a text, otherwise it won't be displayed
     * @param {Element} table
     */
    static clearTableFromInputs(table) {
        if (table) {
            table.querySelectorAll('td').forEach(td => {
                if (td.querySelector(`div[role="combobox"] div[role="button"]`)) {
                    let selectBoxText = '';
                    td.querySelectorAll(`div[role="combobox"] div[role="button"]`).forEach(e => {
                        e.querySelectorAll('div[role="button"]').forEach(v => {
                            if (v.textContent) {
                                //wrap text with <p> tag so every item starts from a new line
                                selectBoxText += `<p>${this.cleanupUserPrompt(v.textContent)}</p>`;
                            }
                        });
                        if (!selectBoxText) {
                            selectBoxText += this.cleanupUserPrompt(e.textContent);
                        }
                    });
                    td.innerHTML = selectBoxText;
                }
                td.querySelectorAll('input').forEach(e => {
                    if (e.type !== 'checkbox') {
                        td.innerHTML = this.cleanupUserPrompt(e.value);
                    }
                    else {
                        td.innerHTML = e.checked ? constants.checkMark : '';
                    }
                });
                td.querySelectorAll('textarea').forEach(e => (td.innerHTML = this.cleanupUserPrompt(e.value)));
                td.querySelectorAll('button').forEach(e => (e.outerHTML = this.cleanupUserPrompt(e.textContent)));
                td.querySelectorAll('ul[role="listbox"] li[aria-selected="true"]').forEach(e => (td.innerHTML = this.cleanupUserPrompt(e.textContent)));
            });
        }
    }
    /**
     * Check if string starts with multiple substrings indicating user prompt
     * @param text
     * @private
     */
    static cleanupUserPrompt(text) {
        const userPrompts = ['Select', 'Enter', 'Click'];
        return dompurify.sanitize(text ? (userPrompts.some(userPrompt => text.trim().startsWith(userPrompt)) ? '' : text.trim()) : '');
    }
    static wrapElementIntoDiv(element) {
        const wrapper = document.createElement('div');
        if (element) {
            if (element instanceof Element) {
                wrapper.append(element);
            }
            else {
                wrapper.innerHTML = element;
            }
        }
        return wrapper;
    }
    static formInfoRow(label, value) {
        return `<p><span class="bold">${label}:</span> ${value}</p>`;
    }
}
/**
 * sets a timeout for a promise. if promise isn't resolved in ms seconds - it will be rejected
 * @param ms
 * @param _widgetName
 * @param promise
 */
Utils.promiseTimeout = (ms, _widgetName, promise) => {
    let id;
    const timeout = new Promise(resolve => {
        id = setTimeout(() => {
            // instead of rejecting and showing an error we keep scraping "as is"
            resolve(true);
        }, ms);
    });
    return Promise.race([promise, timeout]).then(_result => {
        clearTimeout(id);
        return;
    });
};
//# sourceMappingURL=utils.js.map